// extracted by mini-css-extract-plugin
module.exports = {"burger-menu":"BurgerMenu_burger-menu__34heK"};